export const getOfferDeepLink = (state: App.State) => state.system.offerDeepLinkHash
